

<template>
  <q-list>

    <q-item tag="label" class="q-px-none">
      <q-item-section avatar top>
        <q-checkbox v-model="authorizations" val="auth_1" dense></q-checkbox>
      </q-item-section>
      <q-item-section>
        <q-item-label class="text-100 text-blue-grey-8 q-mb-md">
          I am the actual person named in the Customer Information section or the legally authorized immediate family member of that person
          and I am not an agent or representative acting on behalf of that person pursuant to a power of attorney or other similar agent authorization agreement.
        </q-item-label>
      </q-item-section>
    </q-item>


  </q-list>
</template>

<script>
import SelectedPlan from "src/composables/SelectedPlan";
import Utilities from "src/composables/Utilities";
import { watch, ref } from "vue";

export default {
  name: "TxuAuthorizations",
  props: {
    modelValue: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit }) {
    const { selected_plan } = SelectedPlan();
    const { plan_brand, plan_doc_link } = Utilities();
    const authorizations = ref([]);

    watch(authorizations, () => {
      const agreed = authorizations.value.length === 1
      emit('update:modelValue', agreed);
    })

    return {
      authorizations,
      selected_plan,

      plan_brand,
      plan_doc_link
    }
  }
}
</script>

<style scoped>

</style>
